import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiCheck, FiBookOpen, FiCreditCard } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const ProductModal = ({ product, isOpen, onClose }) => {
  if (!product) return null;
  const whatsappUrl = `https://wa.me/529844594738?text=${encodeURIComponent(`Hola! Quiero comprar: ${product.title}`)}`;

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center px-4">
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose} className="absolute inset-0 bg-black/90 backdrop-blur-sm" />
          <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} className="relative bg-zinc-900 border border-zinc-700 rounded-3xl w-full max-w-4xl overflow-hidden flex flex-col shadow-2xl p-8" >
            <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-white">
              <SafeIcon icon={FiX} className="text-2xl" />
            </button>
            
            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <h2 className="text-3xl font-black text-white mb-4 uppercase">{product.title}</h2>
                <div className="bg-zinc-800 p-6 rounded-2xl border border-zinc-700 mb-6">
                  <ul className="space-y-4">
                    {product.features.map((f, i) => (
                      <li key={i} className="flex items-start gap-3 text-gray-300">
                        <SafeIcon icon={FiCheck} className="text-green-500 mt-1" />
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <p className="text-gray-400">{product.description}</p>
              </div>
              
              <div className="flex flex-col justify-center text-center bg-black/40 p-8 rounded-3xl border border-zinc-800">
                <div className="text-5xl font-black text-white mb-2">${product.priceMxn}</div>
                <div className="text-xs text-green-500 font-bold uppercase mb-8">MXN / {product.period}</div>
                
                <div className="space-y-4">
                  {product.stripeUrl && (
                    <a href={product.stripeUrl} target="_blank" rel="noreferrer" className="w-full bg-indigo-600 text-white py-5 rounded-2xl font-black uppercase text-sm flex items-center justify-center gap-3 hover:bg-indigo-500 transition-all shadow-xl">
                      <SafeIcon icon={FiCreditCard} className="text-xl" /> Pagar con Tarjeta
                    </a>
                  )}
                  <a href={whatsappUrl} target="_blank" rel="noreferrer" className="w-full bg-green-600 text-white py-4 rounded-2xl font-black uppercase text-xs flex items-center justify-center gap-2 hover:bg-green-500 transition-all">
                    <SafeIcon icon={FaWhatsapp} /> Comprar por WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default ProductModal;